import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { ExtraWideBody } from '@ui';
import { AI_TOOLS } from '@constants';
import TableAnalysisTool from '@containers/TableAnalysis/TableAnalysisTool';
import { GRID_MODES } from '@containers/gridMode';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.FED_PUBLIC_RELEASE;

function FedTableAnalysis() {
  const [docMode] = React.useState(GRID_MODES.fed);

  return (
    <PageWrapper>
      <Header />
      <ExtraWideBody withFooter>
        <TableAnalysisTool docMode={docMode} tool={tool} />
      </ExtraWideBody>
    </PageWrapper>
  );
}

export default FedTableAnalysis;
